import { TableBody } from "@material-ui/core";
import TableRowCustom from "./TableRowCustom";

const TableBodyCustom = (props) => {
  const { table, filteredRows } = props;

  const { globalFilter } = table.options.state;
  const renderRows = table.getRowModel().rows.filter((el) => {
    if (filteredRows.length > 0) {
      return filteredRows.includes(el.id);
    } else {
      if (globalFilter === "") {
        return true;
      } else {
        return false;
      }
    }
  });
  return (
    <>
      {renderRows.length === 0 ? (
        <div
          style={{
            width: "100%",
            position: "absolute",
            height: "1.5rem",
            left: 0,
            marginTop: "10rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              textAlign: "center",
            }}
          >
            No records found
          </div>
        </div>
      ) : null}
      <TableBody
        style={{
          height: "500px",
          width: "100%",
          border: "2px solid yellow",
          overflow: "Scroll",
        }}
      >
        {renderRows.map((row, index) => {
          return <TableRowCustom row={row} table={table}  />;
        })}
      </TableBody>
    </>
  );
};

export default TableBodyCustom;
